module.exports = __webpack_public_path__ + "img/11.ba1e1bcc.png";